export const tabs = () => {
    console.log('tabs loaded');
    window.addEventListener('load', function () {
        // Show the first tab and hide the rest
        $('.tabHeader li:first-child').addClass('active');
        $('.tabPane').hide();
        $('.tabPane:first').show();

        // Click function
        $('.tabHeader li').click(function(){
        $('.tabHeader li').removeClass('active');
        $(this).addClass('active');
        $('.tabPane').hide();
        
        var activeTab = $(this).find('a').attr('href');
        $(activeTab).fadeIn();
        return false;
        });
        
    })
};
